module.exports = __webpack_public_path__ + "img/xxtd.22ab18a5.png";